import { baseApi } from "../baseApi";

export const deleteApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({

    deleteItem: builder.mutation({

      query: ({ url, id }) => ({
        url: `${url}/${id}`,
        method: "DELETE",
      }),

      invalidatesTags: [
        "Category",
        "SubCategory",
        "State",
        "City",
        "Product",
        "Amenities",
        "Location",
        "Blog",
           "FAQ"
      ],

    }),

  }),

});

export const {
  useDeleteItemMutation,
} = deleteApi;